import { createFileRoute } from "@tanstack/react-router"
import { HeaderedErrorFallback } from "~/components/error"
import { QueryBoundary } from "~/components/query-boundary"
import { Reader } from "../features/reader/components/reader"
import { SpinnerFallback } from "~/components/spinner-fallback"

export const Route = createFileRoute("/document/$id")({
  component: DocumentPage,
})

function DocumentPage() {
  return (
    <div className="flex-1 flex flex-col">
      <QueryBoundary loadingFallback={<SpinnerFallback />} errorFallback={HeaderedErrorFallback}>
        <Reader />
      </QueryBoundary>
    </div>
  )
}
